"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureRendition = exports.configureVariantStream = exports.configureMasterPlaylist = exports.configureMediaPlaylist = exports.parseTagsAndAttributes = exports.PlaylistParser = void 0;

var _attribute_list = require("./attribute_list");

var _playlist = require("../../playlist");

var _segment = require("../../segment");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BASIC_TAGS = ['#EXTM3U', '#EXT-X-VERSION'];
var MEDIA_SEGMENT_TAGS = ['#EXTINF', '#EXT-X-BYTERANGE', '#EXT-X-DISCONTINUITY', '#EXT-X-KEY', '#EXT-X-MAP', '#EXT-X-PROGRAM-DATE-TIME', '#EXT-X-DATERANGE'];
/**
 * Tags that ONLY appear in Media Playlists
 */

var MEDIA_PLAYLIST_TAGS = ['#EXT-X-TARGETDURATION', '#EXT-X-MEDIA-SEQUENCE', '#EXT-X-MEDIA_SEQUENCE', '#EXT-X-DISCONTINUITY-SEQUENCE', '#EXT-X-ENDLIST', '#EXT-X-PLAYLIST-TYPE', '#EXT-X-I-FRAMES-ONLY'];
/**
 * Tags that ONLY appear in Master Playlists
 */

var MASTER_PLAYLIST_TAGS = ['#EXT-X-MEDIA', '#EXT-X-STREAM-INF', '#EXT-X-I-FRAME-STREAM-INF', '#EXT-X-SESSION-DATA', '#EXT-X-SESSION-KEY'];
/**
 * Tags that can appear in BOTH Media and Master Playlists
 */

var MASTER_AND_MEDIA_TAGS = ['#EXT-X-INDEPENDENT-SEGMENTS', '#EXT-X-START'];
var ERRORS = {
  INVALID: 'not valid playlist',
  MIXED_TAGS: 'playlist had media & master tags'
};

var PlaylistParser =
/*#__PURE__*/
function () {
  function PlaylistParser() {
    _classCallCheck(this, PlaylistParser);
  }

  _createClass(PlaylistParser, null, [{
    key: "parse",
    value: function parse(body, startIdx) {
      if (body.slice(0, 7) !== '#EXTM3U') {
        throwError(ERRORS.INVALID);
      }

      var playlistStruct = parseTagsAndAttributes(body);
      var isMedia = isMediaPlaylist(playlistStruct);
      var isMaster = isMasterPlaylist(playlistStruct); // If we have tags for both Media and Master type playlists, something is wrong

      if (isMedia && isMaster) {
        throwError(ERRORS.MIXED_TAGS);
      }

      if (isMedia) {
        return new _playlist.MediaPlaylist(playlistStruct, body, startIdx);
      } // return a MediaPlaylist


      if (isMaster) {
        return new _playlist.MasterPlaylist(playlistStruct, body);
      } // return a MasterPlaylist


      throwError(ERRORS.INVALID);
    }
  }]);

  return PlaylistParser;
}();

exports.PlaylistParser = PlaylistParser;

var throwError = function throwError(err) {
  throw err;
};
/**
 * Used to determine if a parsed playlist struct is a media playlist
 */


var isMediaPlaylist = function isMediaPlaylist(playlistStruct) {
  return findOne(tagsFrom(playlistStruct), MEDIA_PLAYLIST_TAGS);
};
/**
 * Used to determine is a parsed playlist struct is a master playlist
 */


var isMasterPlaylist = function isMasterPlaylist(playlistStruct) {
  return findOne(tagsFrom(playlistStruct), MASTER_PLAYLIST_TAGS);
};
/**
 * Used to extract just the tags from a parsed playlist struct
 */


var tagsFrom = function tagsFrom(playlistStruct) {
  return flattenPlaylist(playlistStruct).filter(function (tag) {
    return tag.slice(0, 1) == '#';
  });
};
/**
 * Used to extract tags / playlist entries WITHOUT attribuets from a parsed playlist struct
 */


var flattenPlaylist = function flattenPlaylist(struct) {
  return struct.map(function (line) {
    switch (line.constructor.name) {
      case 'String':
        return line;

      case 'Object':
        return Object.keys(line)[0];
    }
  });
};
/**
 * Breaks a string by newline characters.  Returns an array with an entry for each line
 */


var componentsFromString = function componentsFromString(body) {
  return body.trim().split('\n');
};
/**
 * Build an array with entries of parsed tags.
 */


var parseTagsAndAttributes = function parseTagsAndAttributes(body) {
  return componentsFromString(body).map(function (line) {
    var comps = line.split(':');

    if (comps.length > 1 && comps[0] !== 'http' && comps[0] !== 'https') {
      return _defineProperty({}, comps[0], _attribute_list.Attribute.parse(comps));
    } else {
      return line;
    }
  });
};
/**
 * Used to find members of an array present in another array
 */


exports.parseTagsAndAttributes = parseTagsAndAttributes;

var findOne = function findOne(haystack, arr) {
  return arr.some(function (x) {
    return haystack.indexOf(x) >= 0;
  });
}; /// Used to configure a media playlist


var configureMediaPlaylist = function configureMediaPlaylist(playlist, struct, startIdx) {
  var currentSegment = undefined;
  var idx = startIdx || 0;
  struct.forEach(function (tag) {
    if (typeof tag === 'string') {
      if (tag === '#EXT-X-ENDLIST') {
        playlist._ended = true;
      } else {
        if (currentSegment) {
          currentSegment.uri = tag;
          playlist.segments.push(currentSegment);
          currentSegment = undefined;
        }
      }
    }

    if (_typeof(tag) === 'object') {
      if (tag['#EXT-X-MAP']) {
        var initSegment = new _segment.MediaInitializationSegment(tag['#EXT-X-MAP']);
        initSegment.id = idx++;
        playlist.segments.push(initSegment);
      }

      if (tag['#EXTINF']) {
        currentSegment = new _segment.MediaSegment(tag['#EXTINF']);
        currentSegment.id = idx++;
      }

      if (tag['#EXT-X-TARGETDURATION']) {
        playlist.targetDuration = tag['#EXT-X-TARGETDURATION'];
      }

      if (tag['#EXT-X-VERSION']) {
        playlist.version = tag['#EXT-X-VERSION'];
      }

      if (tag['#EXT-X-PLAYLIST-TYPE']) {
        playlist._type = tag['#EXT-X-PLAYLIST-TYPE'];
      }

      if (tag['#EXT-X-MEDIA_SEQUENCE']) {
        playlist.mediaSequenceNumber = tag['#EXT-X-MEDIA_SEQUENCE'];
      }

      if (tag['#EXT-X-MEDIA-SEQUENCE']) {
        playlist.mediaSequenceNumber = tag['#EXT-X-MEDIA-SEQUENCE'];
      }
    }
  });
}; /// Used to configure a master playlist


exports.configureMediaPlaylist = configureMediaPlaylist;

var configureMasterPlaylist = function configureMasterPlaylist(playlist, struct) {
  var currentVariant = undefined;
  struct.forEach(function (tag) {
    if (typeof tag === 'string') {
      if (currentVariant) {
        currentVariant.uri = tag;
        currentVariant.basePath = playlist.basePath;
        playlist.variants.push(currentVariant);
        currentVariant = undefined;
      }
    }

    if (_typeof(tag) === 'object') {
      if (tag['#EXT-X-STREAM-INF']) {
        currentVariant = new _playlist.VariantStream(tag['#EXT-X-STREAM-INF']);
      }

      if (tag['#EXT-X-I-FRAME-STREAM-INF']) {
        var variant = new _playlist.VariantStream(tag['#EXT-X-I-FRAME-STREAM-INF']);
        variant.isIFrame = true;
        playlist.variants.push(variant);
      }

      if (tag['#EXT-X-MEDIA']) {
        if (!playlist.renditions) {
          playlist.renditions = [];
        }

        playlist.renditions.push(new _playlist.Rendition(tag['#EXT-X-MEDIA']));
      }
    }
  });
}; /// Used to configure a variant stream


exports.configureMasterPlaylist = configureMasterPlaylist;

var configureVariantStream = function configureVariantStream(variant, streamInfo) {
  if (streamInfo['AVERAGE-BANDWIDTH']) {
    variant.avgBandwidth = streamInfo['AVERAGE-BANDWIDTH'];
  }

  if (streamInfo['CODECS']) {
    variant.codecs = streamInfo['CODECS'];
  }

  if (streamInfo['RESOLUTION']) {
    variant.resolution = streamInfo['RESOLUTION'];
  }

  if (streamInfo['FRAME-RATE']) {
    variant.frameRate = streamInfo['FRAME-RATE'];
  }

  if (streamInfo['CLOSED-CAPTIONS']) {
    variant.closedCaptionsIdent = streamInfo['CLOSED-CAPTIONS'];
  }

  if (streamInfo['URI']) {
    variant.uri = streamInfo['URI'];
  }

  if (streamInfo['AUDIO']) {
    variant.audioIdent = streamInfo['AUDIO'];
  }

  if (streamInfo['SUBTITLES']) {
    variant.subtitlesIdent = streamInfo['SUBTITLES'];
  }
}; /// Used to configure a rendition


exports.configureVariantStream = configureVariantStream;

var configureRendition = function configureRendition(rendition, renditionInfo) {
  rendition.default = optionalYesOrNo(renditionInfo['DEFAULT']);
  rendition.autoselect = optionalYesOrNo(renditionInfo['AUTOSELECT']);
  rendition.forced = optionalYesOrNo(renditionInfo['FORCED']);
  rendition.type = renditionInfo['TYPE'];
  rendition.groupId = renditionInfo['GROUP-ID'];
  rendition.name = renditionInfo['NAME'];

  if (rendition.type != 'CLOSED-CAPTIONS') {
    if (renditionInfo['URI']) {
      rendition.uri = renditionInfo['URI'];
    }
  } else {
    rendition.inStreamId = renditionInfo['INSTREAM-ID'];
  }

  if (rendition.type == 'AUDIO') {
    rendition.channels = renditionInfo['CHANNELS'];
  }

  if (renditionInfo['LANGUAGE']) {
    rendition.language = renditionInfo['LANGUAGE'];
  }

  if (renditionInfo['ASSOC-LANGUAGE']) {
    rendition.assocLanguage = renditionInfo['ASSOC-LANGUAGE'];
  }
};

exports.configureRendition = configureRendition;

var optionalYesOrNo = function optionalYesOrNo(value) {
  if (value && value.toLowerCase() == 'yes') {
    return true;
  }

  return false;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/playlist/playlist-parser.js
// module id = 68
// module chunks = 0